module.exports = __webpack_public_path__ + "static/img/Vizio-Selected.3b4365b.png";


//////////////////
// WEBPACK FOOTER
// ./src/app/assets/destinations/Vizio-Selected.png
// module id = 751
// module chunks = 0